import { createStore, combineReducers, applyMiddleware } from 'redux'
import userReducer from './reducers/userReducer'
import gameReducer from './reducers/gameReducer'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunk from 'redux-thunk'

const combinedReducer = combineReducers({
  user: userReducer, game: gameReducer,
})

const store = createStore(combinedReducer, composeWithDevTools(applyMiddleware(thunk)))

export default store